import { render, staticRenderFns } from "./BusinessManagerDisclaimer.vue?vue&type=template&id=58e4bc34&scoped=true&"
import script from "./BusinessManagerDisclaimer.vue?vue&type=script&lang=js&"
export * from "./BusinessManagerDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./BusinessManagerDisclaimer.vue?vue&type=style&index=0&id=58e4bc34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e4bc34",
  null
  
)

export default component.exports